import { InputTypes } from "../InputTypes";
import { OptionsSources } from "../OptionsSources";
import { Doctor } from "../doctors/Doctor";
import { User } from "../users/User";
import { useUserAppointments } from "../../hooks";
import moment from "moment/moment";

export const UserForm = Object.freeze({
  user_id: {
    visibleName: "Usuario",
    hidden: true,
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: User,
      property: User._id,
      visibleProperty: User.name,
      filter: () => {
        return true;
      },
    },
  },
  doctor_id: {
    visibleName: "Nutricionista",
    type: InputTypes.SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: Doctor,
      property: Doctor._id,
      visibleProperty: Doctor.name,
      filter: () => {
        return true;
      },
    },
  },
  dr_name: {
    visibleName: "Nutricionista",
    type: InputTypes.TEXT,
  },
  session: {
    visibleName: "Sesión",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.INLINE,
      options: [],
    },
  },
  title: {
    visibleName: "Título",
    type: InputTypes.TEXT,
  },
  text: {
    visibleName: "Informe Interno",
    type: InputTypes.RICH_TEXT_AREA,
  },
  text_user: {
    visibleName: "Informe para el Usuario",
    type: InputTypes.RICH_TEXT_AREA,
  },
  url: {
    visibleName: "Archivos anexos",
    type: InputTypes.URL,
    

  },
  visible_user: {
    visibleName: "Visibilidad para el usuario",
    type: InputTypes.PREVIEW,

    /*     type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    }, */
  },
  timestamp: {
    visibleName: "Fecha",
    type: InputTypes.DATE,
  },
  /*
        "last_history": true,*/
});

export const SpecificUserForm = (userId) => {
  const { userAppointments } = useUserAppointments(userId);
  let specificForm = JSON.parse(JSON.stringify(UserForm));
  /*specificForm.session.optionsMapping.collection = SpecificUserIdAppointment(userId);
    specificForm.session.optionsMapping.filter = ()=> {
        return true;
    };*/
  specificForm.session.optionsMapping.options = userAppointments?.map(
    (appointment) => {
      return {
        value: appointment._id,
        label: moment(new Date(appointment.horas_reservadas * 1000)).format(
          "DD/MM/YYYY hh:mm"
        ),
      };
    }
  );

  
  specificForm.session.optionsMapping.options?.push({
    value: "Informe extra", //userAppointments[0]?._id, //"-" //Chapuza inmensa 
    label: "Informe extra",
  });
  console.log("specificForm", specificForm);

  return specificForm;
};
